var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5136 2.97793C16.25 2.54062 14.7967 0.953138 13.7611 1.00106C13.4513 1.02759 13.1774 1.21415 12.9549 1.43152H12.954C12.4439 1.9313 10.9804 3.81745 10.8983 4.21454C10.6954 5.18842 11.8568 5.74982 11.5016 6.73141C10.5961 8.94704 9.0359 10.5071 6.81921 11.4117C5.83839 11.7677 5.27694 10.6073 4.30296 10.8092C3.90584 10.8922 2.01866 12.3548 1.51969 12.8657V12.8657C1.30316 13.0873 1.11487 13.362 1.08919 13.6718C1.05068 14.763 2.73673 16.2358 3.06538 16.424C3.8408 16.9794 4.85243 16.9692 6.08573 16.3958C9.52716 14.9641 15.0269 9.56834 16.4853 5.99714C17.0434 4.7708 17.081 3.75241 16.5136 2.97793Z",
    stroke: "#9BAEBC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86743 1.2085C3.78243 1.551 1.3466 3.98433 0.999932 7.0685",
    stroke: "#9BAEBC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86743 4.16064C5.39243 4.44814 4.23993 5.60064 3.95243 7.07565",
    stroke: "#9BAEBC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalling);
export default __webpack_public_path__ + "static/media/Calling.e47d62eb2ead69d0401d7c8d2e53ec94.svg";
export { ForwardRef as ReactComponent };